/**
 * Country Service
 * Manages country selection and country-specific configurations
 */

export interface Country {
  code: string;
  name: string;
  flag: string;
  currency: string;
  currencySymbol: string;
}

export const COUNTRIES: Record<string, Country> = {
  NG: {
    code: 'NG',
    name: 'Nigeria',
    flag: '🇳🇬',
    currency: 'NGN',
    currencySymbol: '₦',
  },
  GB: {
    code: 'GB',
    name: 'United Kingdom',
    flag: '🇬🇧',
    currency: 'GBP',
    currencySymbol: '£',
  },
  US: {
    code: 'US',
    name: 'United States',
    flag: '🇺🇸',
    currency: 'USD',
    currencySymbol: '$',
  },
};

export const COUNTRY_CODES = Object.keys(COUNTRIES);

export class CountryService {
  private static STORAGE_KEY = 'solynta_selected_country';

  static getSelectedCountry(): Country | null {
    if (typeof window === 'undefined') return null;
    
    const code = localStorage.getItem(this.STORAGE_KEY);
    return code && COUNTRIES[code] ? COUNTRIES[code] : null;
  }

  static setSelectedCountry(countryCode: string): void {
    if (typeof window === 'undefined') return;
    
    if (COUNTRIES[countryCode]) {
      localStorage.setItem(this.STORAGE_KEY, countryCode);
    }
  }

  static clearSelectedCountry(): void {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(this.STORAGE_KEY);
  }

  static getAllCountries(): Country[] {
    return Object.values(COUNTRIES);
  }

  static getCountryByCode(code: string): Country | undefined {
    return COUNTRIES[code];
  }
}
